import type { IntrinsicSystemProps } from '@hover/blueprint';
import { forwardRef, system, transition } from '@hover/blueprint';
import { Component as HoverLogo } from '@hover/tokens-brand/assets/logo-mark--black.svg';
import React from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export interface LogoProps extends IntrinsicSystemProps<'svg'> {}

const Logo = forwardRef<LogoProps, 'svg'>(({ sx, ...props }, ref) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <system.svg
      aria-label={t('navbar.logoAlt')}
      as={HoverLogo}
      color="neutral.0"
      height="300"
      sx={{
        path: {
          fill: 'currentColor !important',
          ...transition.easing250('color'),
        },
        ...sx,
      }}
      {...props}
      ref={ref}
    />
  );
});

export { Logo };
